<template>
  <div class="change_model">
    <el-dialog title="修改密码" :visible="visiblePassword" top="0" append-to-body width="600px" :before-close="closeChangePassword" :show-close="!pswdFlag" :close-on-click-modal="!pswdFlag" :close-on-press-escape="!pswdFlag">
      <el-tabs v-model="activeName" class="custom-tabs">
        <el-tab-pane label="手机验证" name="phoneVerify"></el-tab-pane>
      </el-tabs>
      <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" disabled>
            <template #prepend>+86</template>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <div class="custom-code-input">
            <el-input v-model="ruleForm.code" placeholder="请输入验证码" clearable class="code-input" />
            <el-button :class="isCountingDown ? 'default_button' : 'primary_button'" :type="isCountingDown ? 'default' : 'primary'" :disabled="isCountingDown || sending" @click="sendVerificationCode" class="code-button">
              {{ buttonText }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="closeChangePassword" v-show="!pswdFlag">取消</el-button>
          <el-button type="primary" :loading="submitting" @click="handleNext('ruleForm')">下一步</el-button>
        </div>
      </template>
    </el-dialog>
    <SetNewPassword :showSetNewPassword="showSetNewPassword" :verifyCode="ruleForm.code" @changeSetNewPassword="changeSetNewPassword"></SetNewPassword>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import SetNewPassword from './SetNewPassword.vue';
import { getVerifyCode, checkVerifyCode } from '@/api/verifyCode';
export default {
  props: {
    visiblePassword: {
      type: Boolean,
    },
  },
  components: { SetNewPassword },
  data() {
    return {
      submitting: false,
      codeExpireTime: null, //验证码有效期
      buttonText: '获取验证码', //获取验证码按钮文本
      isCountingDown: false, //验证码发送后的倒计时状态
      sending: false, //验证码是否正在发送的加载状态
      countdown: 60, //倒计时60秒
      activeName: 'phoneVerify',
      ruleForm: {
        phone: '13148473546', // 实际项目中应从用户信息获取
        code: '',
      },
      rules: {
        code: [
          { required: false, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码不正确', trigger: 'blur' },
        ],
      },
      showSetNewPassword: false, //是否展示设置新密码弹框
    };
  },
  computed: {
    ...mapState('user', ['phone', 'passwordState']),
    pswdFlag() {
      return this.passwordState;
    },
  },
  methods: {
    closeChangePassword() {
      this.$emit('changeVisiblePassword', false);
      this.ruleForm.code = '';
      this.buttonText = '获取验证码';
    },
    changeSetNewPassword(value) {
      this.showSetNewPassword = value;
    },
    // 发送验证码
    async sendVerificationCode() {
      if (this.isCountingDown) return;

      this.sending = true;
      try {
        const response = await getVerifyCode({
          phone: this.ruleForm.phone, // 参数会自动拼接到URL
        });
        if (response.data) {
          this.sending = false;
          this.isCountingDown = true;
          this.buttonText = `${this.countdown}s`;
          this.codeExpireTime = new Date().getTime() + 5 * 60 * 1000; // 5分钟有效期

          const timer = setInterval(() => {
            this.countdown--;
            this.buttonText = `${this.countdown}s`;

            if (this.countdown <= 0) {
              clearInterval(timer);
              this.isCountingDown = false;
              this.countdown = 60;
              this.buttonText = '重新发送';
            }
          }, 1000);
          this.$message.success('验证码发送成功');
        }
      } catch (error) {
        this.$message.error('验证码发送失败');
      }
    },
    handleNext() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;

        if (new Date().getTime() > this.codeExpireTime) {
          this.$message.error('验证码超时，请重新获取');
          return;
        }
        checkVerifyCode({
          code: this.ruleForm.code,
          phone: this.ruleForm.phone,
        }).then((response) => {
          // 处理成功响应
          if (response.data) {
            this.$emit('changeVisiblePassword', false);
            this.showSetNewPassword = true;
            this.$message.success(response.msg);
          } else {
            this.$message.error('验证码错误');
          }
        });
      });
    },
  },
  created() {
    this.ruleForm.phone = this.phone;
  },
  mounted() {},
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.custom-code-input {
  display: flex;
  align-items: center;
}

.code-input {
  font-family: auto;
  flex: 1;
  margin-right: 20px; /* 输入框和按钮的间距 */
}

.code-button {
  white-space: nowrap; /* 防止按钮文字换行 */
}
.change_model {
  width: 100%;
  height: 100%;
  position: relative;
}
.custom-tabs {
  ::v-deep .el-tabs__active-bar {
    min-width: 0 !important;
    padding: 0 10px; /* 可以根据需要调整左右间距 */
  }
  ::v-deep .el-tabs__nav-wrap:after {
    border-left: 1px !important;
    width: auto !important;
  }
}
::v-deep .el-input-group__append {
  margin-left: 20px;
  .primary_button {
    background-color: var(--el-color-primary) !important;
    border-color: var(--el-color-primary) !important;
    color: var(--el-button-text-color) !important ;
  }
  .default_button {
    background-color: var(--el-color-default) !important;
    border-color: var(--el-color-default) !important;
    color: var(--el-text-color-regular) !important ;
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
